<template lang="pug">
#global-container
  section.authentication(v-if='locked')
    img.logo(src="@/assets/logo.svg")
    form(@submit="unlock")
      label.label Enter Code
      input.password(
        type='password' 
        maxlength=4 
        v-model="code"
        @input='hasError=false')
      .error(:class='{hidden:!hasError}') Password is incorrect
      button.button Enter
  template(v-else)
    transition(name='fade' mode='out-in')
      router-view(:key='$route.fullPath')
</template>

<script>
export default {
  data(){
    return {
      code: '',
      hasError: false,
    }
  },
  async mounted(){
    this.$store.dispatch('getData')
  },
  computed: {
    locked(){
      return this.$store.state.auth.locked
    },
  },
  methods: {
    async unlock(event){
      event.preventDefault()
      // Totally not secure, but there's no critical info to leak
      const hash = await this.$store.dispatch('hash', this.code)
      if(hash === this.$store.state.auth.hash){
        this.$store.commit('unlock')
      } else{
        this.hasError = true
      }
      return false
    },
  },
  watch: {
    $route: {
      deep: true,
      handler(){
        Array.from(document.querySelectorAll("*")).forEach(el => el.scrollTo(0, 0))
      },
    },
  },
}
</script>

<style lang="sass">
@import "@/sass/main.sass"



</style>
